var cov_2348nb5x0p = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/List.tsx",
      hash = "5b1c30ae2d13a90c8ebb1d130458cc0046cccb33",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/List.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 21
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 16
        }
      },
      "2": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "3": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 52
        }
      },
      "4": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 54
        }
      },
      "5": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 48
        }
      },
      "6": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 18
        }
      },
      "7": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 31
        }
      },
      "8": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 20
        }
      },
      "9": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 24
        }
      },
      "10": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 18
        }
      },
      "11": {
        start: {
          line: 52,
          column: 29
        },
        end: {
          line: 52,
          column: 39
        }
      },
      "12": {
        start: {
          line: 53,
          column: 17
        },
        end: {
          line: 53,
          column: 80
        }
      },
      "13": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 97
        }
      },
      "14": {
        start: {
          line: 54,
          column: 46
        },
        end: {
          line: 54,
          column: 97
        }
      },
      "15": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 69
        }
      },
      "16": {
        start: {
          line: 55,
          column: 32
        },
        end: {
          line: 55,
          column: 69
        }
      },
      "17": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 15
        }
      },
      "18": {
        start: {
          line: 60,
          column: 27
        },
        end: {
          line: 60,
          column: 37
        }
      },
      "19": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 87
        }
      },
      "20": {
        start: {
          line: 61,
          column: 56
        },
        end: {
          line: 61,
          column: 87
        }
      },
      "21": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 91
        }
      },
      "22": {
        start: {
          line: 62,
          column: 30
        },
        end: {
          line: 62,
          column: 91
        }
      },
      "23": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 37
        }
      },
      "24": {
        start: {
          line: 63,
          column: 25
        },
        end: {
          line: 63,
          column: 37
        }
      },
      "25": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 15
        }
      },
      "26": {
        start: {
          line: 68,
          column: 30
        },
        end: {
          line: 68,
          column: 40
        }
      },
      "27": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 38
        }
      },
      "28": {
        start: {
          line: 69,
          column: 32
        },
        end: {
          line: 69,
          column: 38
        }
      },
      "29": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 38
        }
      },
      "30": {
        start: {
          line: 70,
          column: 23
        },
        end: {
          line: 70,
          column: 38
        }
      },
      "31": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 20
        }
      },
      "32": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 24
        }
      },
      "33": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 21
        }
      },
      "34": {
        start: {
          line: 79,
          column: 15
        },
        end: {
          line: 79,
          column: 21
        }
      },
      "35": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 31
        }
      },
      "36": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "37": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 26
        }
      },
      "38": {
        start: {
          line: 92,
          column: 15
        },
        end: {
          line: 92,
          column: 26
        }
      },
      "39": {
        start: {
          line: 93,
          column: 22
        },
        end: {
          line: 93,
          column: 32
        }
      },
      "40": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 89
        }
      },
      "41": {
        start: {
          line: 98,
          column: 51
        },
        end: {
          line: 98,
          column: 61
        }
      },
      "42": {
        start: {
          line: 99,
          column: 28
        },
        end: {
          line: 99,
          column: 44
        }
      },
      "43": {
        start: {
          line: 101,
          column: 20
        },
        end: {
          line: 101,
          column: 49
        }
      },
      "44": {
        start: {
          line: 102,
          column: 25
        },
        end: {
          line: 102,
          column: 71
        }
      },
      "45": {
        start: {
          line: 103,
          column: 19
        },
        end: {
          line: 103,
          column: 40
        }
      },
      "46": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "47": {
        start: {
          line: 117,
          column: 82
        },
        end: {
          line: 117,
          column: 92
        }
      },
      "48": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 104
        }
      },
      "49": {
        start: {
          line: 119,
          column: 17
        },
        end: {
          line: 119,
          column: 104
        }
      },
      "50": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 130,
          column: 5
        }
      },
      "51": {
        start: {
          line: 122,
          column: 20
        },
        end: {
          line: 122,
          column: 46
        }
      },
      "52": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 128,
          column: 7
        }
      },
      "53": {
        start: {
          line: 124,
          column: 20
        },
        end: {
          line: 126,
          column: 20
        }
      },
      "54": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 127,
          column: 87
        }
      },
      "55": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 18
        }
      },
      "56": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 141,
          column: 5
        }
      },
      "57": {
        start: {
          line: 145,
          column: 23
        },
        end: {
          line: 145,
          column: 33
        }
      },
      "58": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 108
        }
      },
      "59": {
        start: {
          line: 146,
          column: 48
        },
        end: {
          line: 146,
          column: 108
        }
      },
      "60": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 90
        }
      },
      "61": {
        start: {
          line: 147,
          column: 32
        },
        end: {
          line: 147,
          column: 90
        }
      },
      "62": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 15
        }
      },
      "63": {
        start: {
          line: 152,
          column: 83
        },
        end: {
          line: 152,
          column: 93
        }
      },
      "64": {
        start: {
          line: 153,
          column: 20
        },
        end: {
          line: 153,
          column: 54
        }
      },
      "65": {
        start: {
          line: 154,
          column: 15
        },
        end: {
          line: 154,
          column: 61
        }
      },
      "66": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 172,
          column: 5
        }
      },
      "67": {
        start: {
          line: 176,
          column: 0
        },
        end: {
          line: 176,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 42
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 25
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 81
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 51
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 49
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 59
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        loc: {
          start: {
            line: 67,
            column: 18
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 67
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 33
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 37
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 77
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 56
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 3
          }
        },
        loc: {
          start: {
            line: 97,
            column: 38
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 97
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 31
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 144,
            column: 2
          },
          end: {
            line: 144,
            column: 3
          }
        },
        loc: {
          start: {
            line: 144,
            column: 17
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 144
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 151,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        },
        loc: {
          start: {
            line: 151,
            column: 11
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 151
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 53,
            column: 35
          },
          end: {
            line: 53,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 35
          },
          end: {
            line: 53,
            column: 39
          }
        }, {
          start: {
            line: 53,
            column: 43
          },
          end: {
            line: 53,
            column: 53
          }
        }],
        line: 53
      },
      "1": {
        loc: {
          start: {
            line: 53,
            column: 55
          },
          end: {
            line: 53,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 55
          },
          end: {
            line: 53,
            column: 64
          }
        }, {
          start: {
            line: 53,
            column: 68
          },
          end: {
            line: 53,
            column: 79
          }
        }],
        line: 53
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 97
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 97
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 97
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 28
          }
        }, {
          start: {
            line: 54,
            column: 32
          },
          end: {
            line: 54,
            column: 44
          }
        }],
        line: 54
      },
      "4": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 69
          }
        }, {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 69
          }
        }],
        line: 55
      },
      "5": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 87
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 87
          }
        }],
        line: 61
      },
      "6": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 18
          }
        }, {
          start: {
            line: 61,
            column: 22
          },
          end: {
            line: 61,
            column: 54
          }
        }],
        line: 61
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 91
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 91
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 91
          }
        }],
        line: 62
      },
      "8": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 37
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 37
          }
        }],
        line: 63
      },
      "9": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 38
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 38
          }
        }],
        line: 69
      },
      "10": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 38
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 38
          }
        }],
        line: 70
      },
      "11": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 21
          }
        }, {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 21
          }
        }],
        line: 79
      },
      "12": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 26
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 26
          }
        }],
        line: 92
      },
      "13": {
        loc: {
          start: {
            line: 98,
            column: 36
          },
          end: {
            line: 98,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 98,
            column: 45
          },
          end: {
            line: 98,
            column: 46
          }
        }],
        line: 98
      },
      "14": {
        loc: {
          start: {
            line: 102,
            column: 40
          },
          end: {
            line: 102,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 40
          },
          end: {
            line: 102,
            column: 60
          }
        }, {
          start: {
            line: 102,
            column: 64
          },
          end: {
            line: 102,
            column: 70
          }
        }],
        line: 102
      },
      "15": {
        loc: {
          start: {
            line: 111,
            column: 9
          },
          end: {
            line: 111,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 27
          },
          end: {
            line: 111,
            column: 82
          }
        }, {
          start: {
            line: 111,
            column: 85
          },
          end: {
            line: 111,
            column: 92
          }
        }],
        line: 111
      },
      "16": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 104
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 104
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 104
          }
        }],
        line: 119
      },
      "17": {
        loc: {
          start: {
            line: 119,
            column: 69
          },
          end: {
            line: 119,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 69
          },
          end: {
            line: 119,
            column: 74
          }
        }, {
          start: {
            line: 119,
            column: 78
          },
          end: {
            line: 119,
            column: 97
          }
        }],
        line: 119
      },
      "18": {
        loc: {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        }, {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        }],
        line: 121
      },
      "19": {
        loc: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 128,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 128,
            column: 7
          }
        }, {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 128,
            column: 7
          }
        }],
        line: 123
      },
      "20": {
        loc: {
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 16
          }
        }, {
          start: {
            line: 123,
            column: 20
          },
          end: {
            line: 123,
            column: 30
          }
        }],
        line: 123
      },
      "21": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 146,
            column: 108
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 146,
            column: 108
          }
        }, {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 146,
            column: 108
          }
        }],
        line: 146
      },
      "22": {
        loc: {
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 14
          }
        }, {
          start: {
            line: 146,
            column: 18
          },
          end: {
            line: 146,
            column: 46
          }
        }],
        line: 146
      },
      "23": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 90
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 90
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 90
          }
        }],
        line: 147
      },
      "24": {
        loc: {
          start: {
            line: 153,
            column: 20
          },
          end: {
            line: 153,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 20
          },
          end: {
            line: 153,
            column: 34
          }
        }, {
          start: {
            line: 153,
            column: 38
          },
          end: {
            line: 153,
            column: 54
          }
        }],
        line: 153
      },
      "25": {
        loc: {
          start: {
            line: 154,
            column: 40
          },
          end: {
            line: 154,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 154,
            column: 40
          },
          end: {
            line: 154,
            column: 46
          }
        }, {
          start: {
            line: 154,
            column: 50
          },
          end: {
            line: 154,
            column: 60
          }
        }],
        line: 154
      },
      "26": {
        loc: {
          start: {
            line: 158,
            column: 39
          },
          end: {
            line: 158,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 39
          },
          end: {
            line: 158,
            column: 47
          }
        }, {
          start: {
            line: 158,
            column: 51
          },
          end: {
            line: 158,
            column: 61
          }
        }],
        line: 158
      },
      "27": {
        loc: {
          start: {
            line: 158,
            column: 63
          },
          end: {
            line: 158,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 63
          },
          end: {
            line: 158,
            column: 68
          }
        }, {
          start: {
            line: 158,
            column: 72
          },
          end: {
            line: 158,
            column: 79
          }
        }],
        line: 158
      },
      "28": {
        loc: {
          start: {
            line: 158,
            column: 81
          },
          end: {
            line: 158,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 81
          },
          end: {
            line: 158,
            column: 88
          }
        }, {
          start: {
            line: 158,
            column: 92
          },
          end: {
            line: 158,
            column: 97
          }
        }],
        line: 158
      },
      "29": {
        loc: {
          start: {
            line: 165,
            column: 9
          },
          end: {
            line: 167,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 9
          },
          end: {
            line: 165,
            column: 16
          }
        }, {
          start: {
            line: 166,
            column: 10
          },
          end: {
            line: 166,
            column: 115
          }
        }],
        line: 165
      },
      "30": {
        loc: {
          start: {
            line: 166,
            column: 49
          },
          end: {
            line: 166,
            column: 108
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 166,
            column: 80
          },
          end: {
            line: 166,
            column: 98
          }
        }, {
          start: {
            line: 166,
            column: 101
          },
          end: {
            line: 166,
            column: 108
          }
        }],
        line: 166
      },
      "31": {
        loc: {
          start: {
            line: 168,
            column: 42
          },
          end: {
            line: 168,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 42
          },
          end: {
            line: 168,
            column: 49
          }
        }, {
          start: {
            line: 168,
            column: 53
          },
          end: {
            line: 168,
            column: 60
          }
        }],
        line: 168
      },
      "32": {
        loc: {
          start: {
            line: 169,
            column: 9
          },
          end: {
            line: 169,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 169,
            column: 9
          },
          end: {
            line: 169,
            column: 17
          }
        }, {
          start: {
            line: 169,
            column: 21
          },
          end: {
            line: 169,
            column: 42
          }
        }, {
          start: {
            line: 169,
            column: 46
          },
          end: {
            line: 169,
            column: 77
          }
        }],
        line: 169
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/List.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, isValidElement } from 'react';
import classnames from 'classnames';
import { getLocale } from '../locale';
import LazyList from '../AnimationList/LazyList';
import { listClass } from './styles';
import { isFunc, isArray, isString } from '../utils/is';
import { getKey } from '../utils/uid';
import { removeStack, addStack } from '../utils/lazyload';
import Spin from '../Spin';
import getDataset from '../utils/dom/getDataset';
import Checkbox from '../Table/Checkbox';
import { isRTL } from '../config';
var DefaultProps = (cov_2348nb5x0p.s[0]++, {
  colNum: 1,
  loading: false,
  size: 'default'
});

var Index =
/*#__PURE__*/
function (_Component) {
  _inherits(Index, _Component);

  var _super = _createSuper2(Index);

  function Index(props) {
    var _this;

    _classCallCheck(this, Index);

    cov_2348nb5x0p.f[0]++;
    cov_2348nb5x0p.s[1]++;
    _this = _super.call(this, props);
    _this.id = void 0;
    _this.node = void 0;
    _this.observer = void 0;
    cov_2348nb5x0p.s[2]++;
    _this.bindNode = _this.bindNode.bind(_assertThisInitialized(_this));
    cov_2348nb5x0p.s[3]++;
    _this.bindObserver = _this.bindObserver.bind(_assertThisInitialized(_this));
    cov_2348nb5x0p.s[4]++;
    _this.scrollLoading = _this.scrollLoading.bind(_assertThisInitialized(_this));
    cov_2348nb5x0p.s[5]++;
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_this));
    cov_2348nb5x0p.s[6]++;
    _this.id = null;
    return _this;
  }

  _createClass(Index, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2348nb5x0p.f[1]++;
      cov_2348nb5x0p.s[7]++;
      removeStack(this.id, true);
      cov_2348nb5x0p.s[8]++;
      this.node = null;
      cov_2348nb5x0p.s[9]++;
      this.observer = null;
      cov_2348nb5x0p.s[10]++;
      this.id = null;
    }
  }, {
    key: "getItemClassName",
    value: function getItemClassName(value, index, flag, isLastCol) {
      cov_2348nb5x0p.f[2]++;

      var _ref = (cov_2348nb5x0p.s[11]++, this.props),
          rowClassName = _ref.rowClassName;

      var base = (cov_2348nb5x0p.s[12]++, listClass('item', (cov_2348nb5x0p.b[0][0]++, flag) && (cov_2348nb5x0p.b[0][1]++, 'checkbox'), (cov_2348nb5x0p.b[1][0]++, isLastCol) && (cov_2348nb5x0p.b[1][1]++, 'item-last')));
      cov_2348nb5x0p.s[13]++;

      if ((cov_2348nb5x0p.b[3][0]++, isFunc(rowClassName)) && (cov_2348nb5x0p.b[3][1]++, rowClassName)) {
        cov_2348nb5x0p.b[2][0]++;
        cov_2348nb5x0p.s[14]++;
        return classnames(base, rowClassName(value, index));
      } else {
        cov_2348nb5x0p.b[2][1]++;
      }

      cov_2348nb5x0p.s[15]++;

      if (isString(rowClassName)) {
        cov_2348nb5x0p.b[4][0]++;
        cov_2348nb5x0p.s[16]++;
        return classnames(base, rowClassName);
      } else {
        cov_2348nb5x0p.b[4][1]++;
      }

      cov_2348nb5x0p.s[17]++;
      return base;
    }
  }, {
    key: "getContent",
    value: function getContent(value, index) {
      cov_2348nb5x0p.f[3]++;

      var _ref2 = (cov_2348nb5x0p.s[18]++, this.props),
          renderItem = _ref2.renderItem;

      cov_2348nb5x0p.s[19]++;

      if ((cov_2348nb5x0p.b[6][0]++, renderItem) && (cov_2348nb5x0p.b[6][1]++, typeof renderItem === 'function')) {
        cov_2348nb5x0p.b[5][0]++;
        cov_2348nb5x0p.s[20]++;
        return renderItem(value, index);
      } else {
        cov_2348nb5x0p.b[5][1]++;
      }

      cov_2348nb5x0p.s[21]++;

      if (isString(renderItem)) {
        cov_2348nb5x0p.b[7][0]++;
        cov_2348nb5x0p.s[22]++;
        return value[renderItem];
      } else {
        cov_2348nb5x0p.b[7][1]++;
      }

      cov_2348nb5x0p.s[23]++;

      if (isString(value)) {
        cov_2348nb5x0p.b[8][0]++;
        cov_2348nb5x0p.s[24]++;
        return value;
      } else {
        cov_2348nb5x0p.b[8][1]++;
      }

      cov_2348nb5x0p.s[25]++;
      return null;
    }
  }, {
    key: "scrollLoading",
    value: function scrollLoading() {
      cov_2348nb5x0p.f[4]++;

      var _ref3 = (cov_2348nb5x0p.s[26]++, this.props),
          scrollLoading = _ref3.scrollLoading;

      cov_2348nb5x0p.s[27]++;

      if (!isFunc(scrollLoading)) {
        cov_2348nb5x0p.b[9][0]++;
        cov_2348nb5x0p.s[28]++;
        return;
      } else {
        cov_2348nb5x0p.b[9][1]++;
      }

      cov_2348nb5x0p.s[29]++;

      if (scrollLoading) {
        cov_2348nb5x0p.b[10][0]++;
        cov_2348nb5x0p.s[30]++;
        scrollLoading();
      } else {
        cov_2348nb5x0p.b[10][1]++;
      }
    }
  }, {
    key: "bindNode",
    value: function bindNode(node) {
      cov_2348nb5x0p.f[5]++;
      cov_2348nb5x0p.s[31]++;
      this.node = node;
    }
  }, {
    key: "bindObserver",
    value: function bindObserver(node) {
      cov_2348nb5x0p.f[6]++;
      cov_2348nb5x0p.s[32]++;
      this.observer = node;
      cov_2348nb5x0p.s[33]++;

      if (!node) {
        cov_2348nb5x0p.b[11][0]++;
        cov_2348nb5x0p.s[34]++;
        return;
      } else {
        cov_2348nb5x0p.b[11][1]++;
      }

      cov_2348nb5x0p.s[35]++;
      removeStack(this.id, true);
      cov_2348nb5x0p.s[36]++;
      this.id = addStack({
        container: this.node,
        element: node,
        render: this.scrollLoading,
        offset: 20,
        noRemove: true
      });
    }
  }, {
    key: "renderCheckBox",
    value: function renderCheckBox(flag, data, index) {
      cov_2348nb5x0p.f[7]++;
      cov_2348nb5x0p.s[37]++;

      if (!flag) {
        cov_2348nb5x0p.b[12][0]++;
        cov_2348nb5x0p.s[38]++;
        return null;
      } else {
        cov_2348nb5x0p.b[12][1]++;
      }

      var _ref4 = (cov_2348nb5x0p.s[39]++, this.props),
          datum = _ref4.datum;

      cov_2348nb5x0p.s[40]++;
      return (
        /*#__PURE__*/
        React.createElement(Checkbox, {
          data: data,
          index: index,
          datum: datum,
          force: datum.check(data),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 94,
            columnNumber: 12
          }
        })
      );
    }
  }, {
    key: "renderItem",
    value: function renderItem(value, index) {
      cov_2348nb5x0p.f[8]++;

      var _ref5 = (cov_2348nb5x0p.s[41]++, this.props),
          keygen = _ref5.keygen,
          onChange = _ref5.onChange,
          data = _ref5.data,
          _ref5$colNum = _ref5.colNum,
          colNum = _ref5$colNum === void 0 ? (cov_2348nb5x0p.b[13][0]++, 1) : _ref5$colNum;

      var haveRowSelected = (cov_2348nb5x0p.s[42]++, isFunc(onChange));
      var content = (cov_2348nb5x0p.s[43]++, this.getContent(value, index));
      var lastColStart = (cov_2348nb5x0p.s[44]++, data.length - ((cov_2348nb5x0p.b[14][0]++, data.length % colNum) || (cov_2348nb5x0p.b[14][1]++, colNum)));
      var isLast = (cov_2348nb5x0p.s[45]++, index >= lastColStart);
      cov_2348nb5x0p.s[46]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: this.getItemClassName(value, index, haveRowSelected, isLast),
          key: getKey(value, keygen, index),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 106,
            columnNumber: 7
          }
        }, this.renderCheckBox(haveRowSelected, value, index), haveRowSelected ? (cov_2348nb5x0p.b[15][0]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: listClass('item-meta'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 111,
            columnNumber: 28
          }
        }, content)) : (cov_2348nb5x0p.b[15][1]++, content))
      );
    }
  }, {
    key: "renderList",
    value: function renderList(isEmpty) {
      cov_2348nb5x0p.f[9]++;

      var _ref6 = (cov_2348nb5x0p.s[47]++, this.props),
          data = _ref6.data,
          empty = _ref6.empty,
          keygen = _ref6.keygen,
          fixed = _ref6.fixed,
          rowsInView = _ref6.rowsInView,
          lineHeight = _ref6.lineHeight,
          value = _ref6.value,
          colNum = _ref6.colNum;

      cov_2348nb5x0p.s[48]++;

      if (isEmpty) {
        cov_2348nb5x0p.b[16][0]++;
        cov_2348nb5x0p.s[49]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: listClass('item', 'empty'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 119,
              columnNumber: 25
            }
          }, (cov_2348nb5x0p.b[17][0]++, empty) || (cov_2348nb5x0p.b[17][1]++, getLocale('noData')))
        );
      } else {
        cov_2348nb5x0p.b[16][1]++;
      }

      cov_2348nb5x0p.s[50]++;

      if (!fixed) {
        cov_2348nb5x0p.b[18][0]++;
        var items = (cov_2348nb5x0p.s[51]++, data.map(this.renderItem));
        cov_2348nb5x0p.s[52]++;

        if ((cov_2348nb5x0p.b[20][0]++, colNum) && (cov_2348nb5x0p.b[20][1]++, colNum > 1)) {
          cov_2348nb5x0p.b[19][0]++;
          var frs = (cov_2348nb5x0p.s[53]++, Array(colNum).fill('1fr').join(' '));
          cov_2348nb5x0p.s[54]++;
          return (
            /*#__PURE__*/
            React.createElement("div", {
              style: {
                display: 'grid',
                gridTemplateColumns: frs
              },
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 127,
                columnNumber: 16
              }
            }, items)
          );
        } else {
          cov_2348nb5x0p.b[19][1]++;
        }

        cov_2348nb5x0p.s[55]++;
        return items;
      } else {
        cov_2348nb5x0p.b[18][1]++;
      }

      cov_2348nb5x0p.s[56]++;
      return (
        /*#__PURE__*/
        React.createElement(LazyList, {
          lineHeight: lineHeight,
          data: data,
          keygen: keygen,
          renderItem: this.renderItem,
          itemsInView: rowsInView,
          force: value,
          colNum: colNum,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 132,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      cov_2348nb5x0p.f[10]++;

      var _ref7 = (cov_2348nb5x0p.s[57]++, this.props),
          footer = _ref7.footer;

      cov_2348nb5x0p.s[58]++;

      if ((cov_2348nb5x0p.b[22][0]++, footer) && (cov_2348nb5x0p.b[22][1]++, typeof footer === 'function')) {
        cov_2348nb5x0p.b[21][0]++;
        cov_2348nb5x0p.s[59]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: listClass('footer'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 146,
              columnNumber: 56
            }
          }, footer())
        );
      } else {
        cov_2348nb5x0p.b[21][1]++;
      }

      cov_2348nb5x0p.s[60]++;

      if (
      /*#__PURE__*/
      isValidElement(footer)) {
        cov_2348nb5x0p.b[23][0]++;
        cov_2348nb5x0p.s[61]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: listClass('footer'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 147,
              columnNumber: 40
            }
          }, footer)
        );
      } else {
        cov_2348nb5x0p.b[23][1]++;
      }

      cov_2348nb5x0p.s[62]++;
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      cov_2348nb5x0p.f[11]++;

      var _ref8 = (cov_2348nb5x0p.s[63]++, this.props),
          data = _ref8.data,
          loading = _ref8.loading,
          style = _ref8.style,
          size = _ref8.size,
          bordered = _ref8.bordered,
          fixed = _ref8.fixed,
          height = _ref8.height,
          scrollLoading = _ref8.scrollLoading;

      var isEmpty = (cov_2348nb5x0p.s[64]++, (cov_2348nb5x0p.b[24][0]++, !isArray(data)) || (cov_2348nb5x0p.b[24][1]++, data.length <= 0));
      var ms = (cov_2348nb5x0p.s[65]++, Object.assign({}, style, (cov_2348nb5x0p.b[25][0]++, height) && (cov_2348nb5x0p.b[25][1]++, {
        height: height
      })));
      cov_2348nb5x0p.s[66]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: classnames(listClass('container', size, (cov_2348nb5x0p.b[26][0]++, bordered) && (cov_2348nb5x0p.b[26][1]++, 'bordered'), (cov_2348nb5x0p.b[27][0]++, fixed) && (cov_2348nb5x0p.b[27][1]++, 'fixed'), (cov_2348nb5x0p.b[28][0]++, isRTL()) && (cov_2348nb5x0p.b[28][1]++, 'rtl')), this.props.className),
          style: ms,
          ref: this.bindNode
        }, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 156,
            columnNumber: 7
          }
        }), (cov_2348nb5x0p.b[29][0]++, loading) && (cov_2348nb5x0p.b[29][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: listClass('loading'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 166,
            columnNumber: 11
          }
        }, typeof loading === 'boolean' ? (cov_2348nb5x0p.b[30][0]++,
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 40,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 166,
            columnNumber: 81
          }
        })) : (cov_2348nb5x0p.b[30][1]++, loading))),
        /*#__PURE__*/
        React.createElement("div", {
          className: listClass('list', (cov_2348nb5x0p.b[31][0]++, isEmpty) && (cov_2348nb5x0p.b[31][1]++, 'empty')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 168,
            columnNumber: 9
          }
        }, this.renderList(isEmpty)), (cov_2348nb5x0p.b[32][0]++, !isEmpty) && (cov_2348nb5x0p.b[32][1]++, isFunc(scrollLoading)) && (cov_2348nb5x0p.b[32][2]++,
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindObserver,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 169,
            columnNumber: 47
          }
        })), this.renderFooter())
      );
    }
  }]);

  return Index;
}(Component);

Index.defaultProps = DefaultProps;
Index.displayName = void 0;
cov_2348nb5x0p.s[67]++;
Index.displayName = 'ShineoutList';
export default Index;